import { AgendamentoConsultaAtendimentoInput, AgendamentoConsultasAtendimentoInput } from 'graphql/types.generated'
import { compact } from 'util/array'
import { isObjectDeepEmpty } from 'util/object'
import { LotacaoAgendamentoConflitanteInput } from 'view/agenda/model-agenda'

import { AgendarConsultaPanelModel } from './AgendarConsultaPanel'
import { convertPlanejadas } from './converter-proximasConsultas'
import {
  AgendarConsultaSectionModel,
  ProximaConsultaTypeEnum,
  SugestaoProximaConsultaModel,
} from './model-agendarConsultaAtendimento'

export const convertAgendarConsultas = (
  agendarConsulta: AgendarConsultaPanelModel | undefined,
  showHorarioFinal: boolean
): AgendamentoConsultasAtendimentoInput | undefined => {
  return isObjectDeepEmpty(agendarConsulta)
    ? undefined
    : {
        avulsa: convertAgendarConsulta(agendarConsulta?.avulsa, showHorarioFinal),
        planejadas: convertPlanejadas(agendarConsulta?.proximasConsultas, showHorarioFinal),
        enviarComprovantesParaCidadao: !!agendarConsulta?.comprovante?.enviarParaCidadao,
      }
}

export const convertSugestaoConsultaPreNatalToSugestaoProximaConsultaModel = (
  sugestao: LocalDate
): SugestaoProximaConsultaModel => ({
  date: sugestao,
  type: ProximaConsultaTypeEnum.PRE_NATAL,
})

export const convertSugestaoConsultaOdontoToSugestaoProximaConsultaModel = (
  sugestao: LocalDate
): SugestaoProximaConsultaModel => ({
  date: sugestao,
  type: ProximaConsultaTypeEnum.ODONTOLOGICO,
})

const convertAgendarConsultaToAgendamentosConflitantesInput = (
  agendarConsulta: AgendarConsultaSectionModel
): LotacaoAgendamentoConflitanteInput => {
  return agendarConsulta?.lotacao?.profissional && agendarConsulta?.horario?.inicial
    ? {
        lotacaoId: agendarConsulta.lotacao.id,
        profissionalId: agendarConsulta.lotacao.profissional.id,
        horario: Number(agendarConsulta.horario?.inicial),
      }
    : null
}

export const convertAgendarConsultasToAgendamentosConflitantesInput = (
  agendarConsulta: AgendarConsultaPanelModel
): LotacaoAgendamentoConflitanteInput[] => {
  return compact([
    convertAgendarConsultaToAgendamentosConflitantesInput(agendarConsulta?.avulsa),
    convertAgendarConsultaToAgendamentosConflitantesInput(agendarConsulta?.proximasConsultas?.proximaConsultaPreNatal),
    convertAgendarConsultaToAgendamentosConflitantesInput(
      agendarConsulta?.proximasConsultas?.proximaConsultaOdontologica
    ),
  ])
}

export const convertAgendarConsulta = (
  agendarConsulta: AgendarConsultaSectionModel | undefined,
  showHorarioFinal: boolean
): AgendamentoConsultaAtendimentoInput | undefined =>
  agendarConsulta?.lotacao
    ? {
        lotacao: agendarConsulta.lotacao.id,
        horarioInicial: Number(agendarConsulta.horario?.inicial),
        ...(showHorarioFinal &&
          agendarConsulta.horario?.final && { horarioFinal: Number(agendarConsulta.horario.final) }),
        isForaUbs: !!agendarConsulta.isForaUbs,
        localAtendimento: agendarConsulta.localAtendimento?.id,
        observacoes: agendarConsulta.observacoes,
      }
    : undefined
